import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Injector, Input, model, OnDestroy, signal, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IIcerik, IKart, IKartTuru, IUyarVT, IUyarYollar, TurGizlilik, TurGizlilikBilgi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { ServisUyarProjeler } from '@/src/app/uygulamalar/uyar-dokum/projeler/projeler.service';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ServisUyarService } from '@/src/app/uygulamalar/uyar-dokum/servis-uyar.service';
import { RouterModule } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IParametre } from '@/src/service/fikoyt-ui/interfaces/IParametre/IParametre';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { ParametrelerComponent } from '@/src/service/fikoyt-ui/src/lib/parametreler/parametreler.component';
import { FirmaEkleComponent } from './firma-ekle/.component';
import { TeklifOlusturComponent } from './teklif-olustur/.component';
import { UyarPersonelEkeComponent } from './personel-ekle/.component';
import { PersonelEkleSet, FirmaOlusturSet, TeklifOlusturSet } from './IVeriSetleri';

declare var $: any;

@Component({
  selector: 'paylas-uyar-kutusu',
  templateUrl: './uyar-kutusu.component.html',
  styleUrls: ['./uyar-kutusu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    NzPopconfirmModule,
    NzWaveModule,
    NzButtonModule,
    NzInputModule,
    RouterModule,
    ParametrelerComponent,
  ],

})
export class IUyarKartComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  @Input() kart: IKart | undefined;
  @Input() icerik: IIcerik | undefined;


  /** */
  rota = model("ana-sayfa");


  constructor(public servisUyarProjeler: ServisUyarProjeler, public servisUyar: ServisUyarService) {
    super();
    // setTimeout(() => {
    //   this.CD.detach();
    // })

    this.subsList.push(this.FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    }));
  }

  tiklandiFirmaOlustur() {
    this.icerik.ek.parametreler = FirmaOlusturSet;
    this.icerik.ek.vt = 'FikoYT.Uyar.firmalar' as IUyarVT;
    this.icerik.ek.yol = 'FikoYT.Uyar.firmalar.kalem' as IUyarYollar;
    this.CD.detectChanges();
    this.rota.set('firma');
  }
  tiklandiPersonelEkle() {
    this.icerik.ek.parametreler = PersonelEkleSet;
    this.icerik.ek.vt = 'FikoYT.Uyar.firmalar.personeller' as IUyarVT;
    this.icerik.ek.yol = 'FikoYT.Uyar.firmalar.personeller.kalem' as IUyarYollar;
    this.CD.detectChanges();
    this.rota.set('personel');
  }

  tiklandiTeklifOlustur() {
    this.icerik.ek.parametreler = TeklifOlusturSet;
    this.icerik.ek.vt = 'FikoYT.Uyar.teklifler' as IUyarVT;
    this.icerik.ek.yol = 'FikoYT.Uyar.teklifler.kalem' as IUyarYollar;
    this.CD.detectChanges();
    this.rota.set('teklif');
  }


  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }



}
